function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M20.11 3.9A11.375 11.375 0 0012 .54C8.93.54 6.06 1.73 3.89 3.9a11.375 11.375 0 00-3.36 8.11c0 3.07 1.19 5.94 3.36 8.11A11.44 11.44 0 0012 23.47c2.94 0 5.87-1.12 8.11-3.35 4.47-4.48 4.47-11.75 0-16.22zm-.85 15.36c-4 4-10.51 4-14.51 0A10.205 10.205 0 011.74 12c0-2.74 1.07-5.32 3.01-7.26 1.94-1.94 4.52-3.01 7.26-3.01s5.32 1.07 7.26 3.01c3.99 4.01 3.99 10.52-.01 14.52z",
  fill: "#1092DC"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.6 11.77V6.51c0-.33-.27-.6-.6-.6-.33 0-.6.27-.6.6v5.5c0 .15.06.3.16.41l3.8 4.1c.12.13.28.19.44.19a.6.6 0 00.44-1.01l-3.64-3.93z",
  fill: "#1092DC"
});

function SvgPending(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "a377b6822578e36f9e2429960a95f47f.svg";
export { SvgPending as ReactComponent };